<template>
  <card-view :toLink="currentLink">
    <AutoComplete
      type="text"
      v-model="searchQuery"
      @input="search"
      @item-select="selectResult"
      @clear="validAddress.data = undefined"
      placeholder="Search for an Address"
      :suggestions="searchData"
      :scrollHeight="'300'"
      :minLength="3"
      field="place_name"
    >
    </AutoComplete>
    <template v-slot:footer-button>
      <router-link
        :to="validAddress.data === undefined ? '' : 'scorecard'"
        style="text-decoration: none; color: inherit"
      >
        <Button
          label="Get Scorecard"
          class="p-button-raised"
          style="margin-left: 0.5em"
          :disabled="validAddress.data === undefined"
        />
      </router-link>
    </template>
  </card-view>
</template>

<script>
import CardView from "./CardView.vue";
import { ref } from "vue";
import axios from "axios";
import { validAddress } from "../state";

export default {
  components: { CardView },
  name: "home",
  setup() {
    let searchQuery = ref(null);
    const searchData = ref(null);
    const queryTimeout = ref(null);

    const search = () => {
      clearTimeout(queryTimeout.value);
      searchData.value = null;
      queryTimeout.value = setTimeout(async () => {
        if (searchQuery.value !== "") {
          const params = new URLSearchParams({
            fuzzyMatch: true,
            language: "en",
            limit: 10,
            country: "us",
          });
          const getData = await axios.get(
            `/api/search/${searchQuery.value}?${params}`
          );
          searchData.value = getData.data.features;
        }
      }, 750);
    };

    if (validAddress.data) {
      searchQuery.value = validAddress.data.value
    }

    const selectResult = (result) => {
      validAddress.data = result;
    };

    return {
      searchQuery,
      searchData,
      queryTimeout,
      search,
      selectResult,
      currentLink: "scorecard",
      validAddress,
    };
  },
};
</script>